import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  getEncounterChartData,
  getMemberChartData,
} from "../../services/CareTeam";
import { showToastError } from "../../Utils/Helper";
import FilterButtonSelect from "../../commonComponent/FilterButtonSelect";
import { useAuth } from "../../Context/AuthContext";

const CareTeamChart = () => {
  const navigate = useNavigate();
  const [totalMember, setTotalMember] = useState();
  const [totalEncounter, setTotalEncounter] = useState();
  const [filterMemberBy, setFilterMemberBy] = useState("weekly");
  const [filterEncounterBy, setFilterEncounterBy] = useState("weekly");
  const {isAdmin} = useAuth()
  useEffect(() => {
    getTotalMemberChartData();
  }, [filterMemberBy]);

  useEffect(() => {
    getTotalEncounterChartData();
  }, [filterEncounterBy]);

  const options = {
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
    },
    maintainAspectRatio: false,
  };
  const getTotalMemberChartData = async () => {
    let param = filterMemberBy;
    try {
      const response = await getMemberChartData(param);
      if (response.status !== 200) {
        showToastError("Something wrong in API request");
      }
      setTotalMember(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getTotalEncounterChartData = async () => {
    let param = filterEncounterBy;
    try {
      const response = await getEncounterChartData(param);
      if (response.status !== 200) {
        showToastError("Something wrong in API request");
      }
      setTotalEncounter(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const filterOptions = [
    {
      label: "Weekly",
      value: "weekly",
    },
    {
      label: "Monthly",
      value: "monthly",
    },
    {
      label: "Quarterly",
      value: "quarterly",
    },
    {
      label: "Yearly",
      value: "yearly",
    },
  ];

  const resObj = {
    0: 100,
    5: 200,
    10: 150,
    15: 250,
    20: 200,
    25: 250,
    30: 500,
  };

  const getMemberObj = () => {
    let dataToUse;
    let keyToUse;

    switch (filterMemberBy) {
      case "weekly":
        dataToUse = totalMember?.dayData;
        keyToUse = "dayName";
        break;
      case "monthly":
        dataToUse = totalMember?.weekData;
        keyToUse = "WeekName";
        break;
      case "quarterly":
        dataToUse = totalMember?.quarterData;
        keyToUse = "WeekName";
        break;
      case "yearly":
        dataToUse = totalMember?.monthData;
        keyToUse = "monthName";
        break;
      default:
        return [];
    }

    return (
      dataToUse?.reduce((acc, { [keyToUse]: name, count }) => {
        acc[name] = count;
        return acc;
      }, {}) || []
    );
  };

  const getEncounterObj = () => {
    let dataToUse;
    let keyToUse;

    switch (filterEncounterBy) {
      case "weekly":
        dataToUse = totalEncounter?.dayData;
        keyToUse = "dayName";
        break;
      case "monthly":
        dataToUse = totalEncounter?.weekData;
        keyToUse = "WeekName";
        break;
      case "quarterly":
        dataToUse = totalEncounter?.quarterData;
        keyToUse = "WeekName";
        break;
      case "yearly":
        dataToUse = totalEncounter?.monthData;
        keyToUse = "monthName";
        break;
      default:
        return [];
    }

    return (
      dataToUse?.reduce((acc, { [keyToUse]: name, count }) => {
        acc[name] = count;
        return acc;
      }, {}) || []
    );
  };

  const data = {
    labels: Object.keys(
      Object.fromEntries(Object.entries(getMemberObj()).reverse()) || resObj
    ),
    datasets: [
      {
        label: "Total Members",
        data: Object.values(getMemberObj() || resObj)?.reverse(),
        fill: {
          target: "origin",
          above: "rgba(218, 129, 132, 0.4)", // Gradient color
          below: "rgba(202, 107, 110, 0)", // Transparent color
        },
        borderColor: "rgba(218, 129, 132, 1)", // Line color
        tension: 0.4, // Tension for smoothing the line
        pointRadius: 0, // Set the point radius to 0 to remove points
      },
    ],
  };

  const data2 = {
    labels: Object.keys(
      Object.fromEntries(Object.entries(getEncounterObj()).reverse()) || resObj
    ),
    datasets: [
      {
        label: "Total Encounters",
        data: Object.values(getEncounterObj() || resObj)?.reverse(),
        fill: {
          target: "origin",
          above: "rgba(218, 129, 132, 0.4)", // Gradient color
          below: "rgba(202, 107, 110, 0)", // Transparent color
        },
        borderColor: "rgba(218, 129, 132, 1)", // Line color
        tension: 0.4, // Tension for smoothing the line
        pointRadius: 0, // Set the point radius to 0 to remove points
      },
    ],
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <div className="chartbox_chart5 py-3 px-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="chidHeadFont fw-semibold">
                {totalMember?.totalMembers}
              </div>
              <div className="headFont fw-semibold ">Total Members</div>
              <FilterButtonSelect
                options={filterOptions}
                filterBy={filterMemberBy}
                setFilterBy={setFilterMemberBy}
              />
            </div>
            <Line height={"100%"} options={options} data={data} />
          </div>
          {isAdmin && (
            <p
              className="careteam_para0 mt-2 pointer"
              onClick={() => navigate("/viewpatientlist")}
            >
              View List <MdArrowForwardIos />
            </p>
          )}
        </div>

        <div className="col-md-6">
          <div className="chartbox_chart5 py-3 px-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="chidHeadFont fw-semibold">
                {totalEncounter?.totalMembers}
              </div>
              <div className="headFont fw-semibold">Total Encounters</div>{" "}
              <FilterButtonSelect
                options={filterOptions}
                filterBy={filterEncounterBy}
                setFilterBy={setFilterEncounterBy}
              />
            </div>
            <Line height={"100%"} options={options} data={data2} />
          </div>
          <p className="careteam_para0 mt-2">
            {/* View Charts <MdArrowForwardIos /> */}
          </p>
        </div>
      </div>
    </>
  );
};

export default CareTeamChart;
